var $8cdc60ee01e5e7f8$exports = {};
$8cdc60ee01e5e7f8$exports = {
    "collapse": `Contraer`,
    "expand": `Ampliar`
};


export {$8cdc60ee01e5e7f8$exports as default};
//# sourceMappingURL=es-ES.module.js.map
